import Alert from 'react-bootstrap/Alert'
import Card from 'react-bootstrap/Card'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import { useState } from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'
import { SubmitButton, TextField, useFormState } from '../components/form'

export function LoginPage() {
    const { user, login } = useAuth()
    const navigate = useNavigate()
    const location = useLocation()
    const [failed, setFailed] = useState(false)

    const form = useFormState({
        initialValues: { login: '', password: '' },
        onSubmit: async (values) => {
            setFailed(false)
            const result = await login(values.login, values.password)
            if (!result.ok) {
                setFailed(!result.fieldErrors)
                return { fieldErrors: result.fieldErrors }
            }
            const target = (location.state as { from?: string } | null)?.from ?? '/'
            navigate(target, { replace: true })
        },
    })

    if (user) {
        return <Navigate to="/" replace />
    }

    return (
        <Row className="justify-content-center">
            <Col xs={12} sm={10} md={6} lg={4}>
                <Card className="mt-4">
                    <Card.Body>
                        <h1 className="h4 mb-1">Přihlášení</h1>
                        <p className="text-secondary small">Účet vám zakládá správce aplikace.</p>

                        {failed && (
                            <Alert variant="danger" className="py-2">
                                Přihlášení se nezdařilo. Zkontrolujte jméno a heslo.
                            </Alert>
                        )}

                        <form onSubmit={form.handleSubmit} noValidate>
                            <TextField
                                label="Přihlašovací jméno"
                                value={form.values.login}
                                onChange={(value) => form.setValue('login', value)}
                                error={form.fieldErrors.login}
                                autoComplete="username"
                                autoFocus
                                required
                            />
                            <TextField
                                label="Heslo"
                                type="password"
                                value={form.values.password}
                                onChange={(value) => form.setValue('password', value)}
                                error={form.fieldErrors.password}
                                autoComplete="current-password"
                                required
                            />
                            <SubmitButton submitting={form.submitting} className="w-100">
                                Přihlásit se
                            </SubmitButton>
                        </form>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    )
}
